
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import {deepClone} from "@/utils/deepClone";
import {
  getAllowType,
  getclosureOrder,
  getClosureOrderSetting,
  getClosureOrderType,
  getClosureType,
  getNotion,
  getRelateOrderId,
  invalidClosureOrder,
  postClosureOrder,
  postExecuteTime,
  putClosureOrderSetting,
  revertClosureOrder
} from "@/api/closing-order";
import {getRecipients} from "@/api/mails";
import {searchAllCustomer, searchCustomer} from "@/api/customer";

@Component({
  name: "closingPositionManagementInfo",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private isExporting = false;
  private showCancelDialog = false;
  private CancelDialogContent = "";
  private showWithdrawDialog = false;
  private WithdrawDialogContent = "";
  private showCreateClosingPosition = false;
  private createWidth = "900px";
  private showEditProcessed = false;
  private showProcessed = false;
  private tableLoading = false;
  private editProcessed = {
    chu: [],
    ping: [],
    remark: "",
    id: "",
  };
  private selectId = "";
  private rulesMain = {
    company: [{ required: true, message: "请选择公司类型" }],
    status: [{ required: true, message: "请选择平仓类型" }],
    remark: [{ required: true, message: "请输入平仓说明" }],
  };
  private rulesBack = {
    guest: [{ required: true, message: "请选择客人信息" }],
    orderStatus: [{ required: true, message: "请选择关联单据类型" }],
    code: [{ required: true, message: "请输入关联单据号" }],
  };
  private rulesBackFKD = {
    orderStatus: [{ required: true, message: "请选择关联单据类型" }],
    code: [{ required: true, message: "请输入关联单据号" }],
  };
  private rulesError = {
    guest: [{ required: true, message: "请选择客人信息" }],
    orderStatus: [{ required: true, message: "请选择关联单据类型" }],
    code: [{ required: true, message: "请输入装箱单号" }],
  };
  private rulesAdjust = {
    guest: [{ required: true, message: "请选择客人信息" }],
    orderStatus: [{ required: true, message: "请选择关联单据类型" }],
    code: [{ required: true, message: "请输入装箱单号" }],
  };
  private rulesAdjust1 = {
    guest1: [{ required: true, message: "请选择客人信息" }],
    orderStatus1: [{ required: true, message: "请选择关联单据类型" }],
    code1: [{ required: true, message: "请输入关联单据号" }],
    deliveryNoteId: [{ required: true, message: "请输入指定进仓单号" }],
  };
  private createClosingPosition = {
    company: "",
    status: "",
    reamrk: "",
    important: "",
    code: null,
    orderStatus: "",
    guest: "",
    guest1: "",
    orderStatus1: "",
    code1: null,
    deliveryNoteId: null
  } as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  public listParam = {
    createStartTime: null,
    createEndTime: null,
    code: null,
    type: null,
    relationType: null,
    relationCode: null,
    approveId: null,
    handlerId: null,
    state: null,
    executeStartTime: null,
    executeEndTime: null
  };
  private searchForm = [
    {
      label: "平仓单",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      placeholder: "",
    },
    {
      label: "关联单据类型",
      prop: "orderType",
      key: "orderType",
      type: "select",
      value: "",
      placeholder: "请选择关联单据类型",
      clearable: true,
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "平仓类型",
      prop: "type",
      key: "type",
      type: "select",
      value: "",
      placeholder: "请选择平仓类型",
      clearable: true,
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "创建时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      valueFormat: "yyyy-MM-dd",
      value: "",
    },
    {
      label: "关联单据号",
      prop: "relateCode",
      key: "relateCode",
      type: "input",
      value: "",
    },
    {
      label: "审核人",
      prop: "approveId",
      key: "approveId",
      type: "select",
      value: "",
      clearable: true,
      options: [],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "处理人",
      prop: "handlerId",
      key: "handlerId",
      type: "select",
      value: "",
      clearable: true,
      options: [],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "审核状态",
      prop: "state",
      key: "state",
      type: "select",
      value: "",
      placeholder: "",
      clearable: true,
      options: [
        {
          label: "新建",
          value: "CREATE",
        },
        {
          label: "待审核",
          value: "APPROVE",
        },
        {
          label: "已挂起",
          value: "PENDING",
        },
        {
          label: "审核通过",
          value: "FINISH",
        },
        {
          label: "创建人作废",
          value: "INVALID_BY_CREATOR",
        },
        {
          label: "审核人作废",
          value: "INVALID_BY_APPROVAL",
        },
      ],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "执行时间",
      prop: "executeTime",
      key: "executeTime",
      type: "datePicker",
      value: "",
      valueFormat: "yyyy-MM-dd"
    },
  ];
  private tableCol = [
    {
      label: "平仓单编号",
      prop: "code",
      key: "code",
      type: "link",
      show: true,
      disabled: false,
      width: 150,
    },
    {
      label: "关联单据类型",
      prop: "relationType",
      key: "relationType",
      show: true,
      disabled: false,
    },
    {
      label: "关联单据号",
      prop: "relationCode",
      key: "relationCode",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "hqPackingCode",
      key: "hqPackingCode",
      show: true,
      disabled: false,
    },
    {
      label: "平仓类型",
      prop: "typeDesc",
      key: "typeDesc",
      show: true,
      disabled: false,
    },
    {
      label: "创建人",
      prop: "handlerName",
      key: "handlerName",
      show: true,
      disabled: false,
    },
    {
      label: "平仓操作总量",
      prop: "productTotalNum",
      key: "productTotalNum",
      show: true,
      disabled: false,
    },
    {
      label: "审核人",
      prop: "approveName",
      key: "approveName",
      show: true,
      disabled: false,
    },
    {
      label: "审核状态",
      prop: "stateDesc",
      key: "stateDesc",
      show: true,
      disabled: false,
    },
    {
      label: "执行时间",
      prop: "executeTime",
      key: "executeTime",
      show: true,
      disabled: false,
    },
    {
      label: "审核说明",
      prop: "approveReason",
      key: "approveReason",
      show: true,
      disabled: false,
    },
    {
      label: "平仓说明",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdAt",
      key: "createdAt",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "查看平仓",
          code: "",
          click: "lookClosing",
          key: "state",
          value: "CREATE,PENDING,FINISH,INVALID_BY_CREATOR,INVALID_BY_APPROVAL",
        },
        {
          name: "作废",
          code: "",
          click: "handleCancel",
          key: "state",
          value: "CREATE",
        },
        {
          name: "撤回",
          code: "",
          click: "handleWithdraw",
          key: "state",
          value: "APPROVE",
        },
        {
          name: "执行",
          code: "",
          click: "handelExecute",
          key: 'state',
          value: 'FINISH'
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    },
  ] as any;
  private processedList = [];
  private processedCol = [
    {
      label: "平仓类型",
      prop: "typeDesc",
      key: "typeDesc",
      show: true,
      disabled: false,
      width: 150,
    },
    {
      label: "平仓处理人",
      prop: "examineName",
      key: "examineName",
      show: true,
      disabled: false,
    },
    {
      label: "审核处理人",
      prop: "closingName",
      key: "closingName",
      show: true,
      disabled: false,
    },
    {
      label: "场景描述",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑",
          code: "",
          click: "handleProcessedEdit",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;
  created() {
    if(this.$route.query.code) {
      this.listParam.code = this.$route.query.code;
      this.searchForm.find(e => e.key === "code").value = this.$route.query.code as any;
    }
    this.init();
  }
  private init() {
    this.searchCustomer();
    this.getCustomer();
    this.getCustomer1();
    this.getList();
    this.getAllowType();
    this.getClosureType();
    this.getClosureOrderType();
  }
  private searchCustomerList = [];
  private searchCustomerList1 = [];
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchCustomerList = res;
  }

  /**
   * 只为调配库存调入客人允许查询所有客人
   * @param name
   * @private
   */
  private async getCustomer2(name = "") {
    const res: any = await searchAllCustomer({ keyword: name });
    this.searchCustomerList = res;
  }

  private async getCustomer1(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchCustomerList1 = res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.tableLoading = true;
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const { total, content }: any = await getclosureOrder(params);
    this.table.total = +total;
    content.map((e) => {
      e.approveName = e.approve ? e.approve.name : null;
      e.handlerName = e.handler ? e.handler.name : null;
      e.relationType = e.relateOrders
        ? e.relateOrders.filter(e => e.relateType !== 'DELIVERY')
            .map((ut) => {
              return ut.orderTypeDesc;
            })
        : null;
      e.relationType = Array.from(new Set(e.relationType)).toString();
      e.relationCode = e.relateOrders
        ? e.relateOrders.filter(e => e.relateType !== 'DELIVERY')
            .map((ut) => {
              return ut.code;
            })
            .toString()
        : null;
      if (e.relateOrders && e.relateOrders.length > 0) {
        let newArr = [];
        e.relateOrders.map((ut) => {
          if (ut.orderType === "HQ_PACKING_LIST") {
            newArr.push(ut.code);
          }
        });
        e.hqPackingCode = newArr.toString();
      } else {
        e.hqPackingCode = null;
      }
    });
    this.loading = false;
    this.table.list = content;
    (this.$refs.query as any).finishLoading();
  }
  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    // this.listParam = rest;
    this.listParam = data && data !== "reset" ? data : {};
    if (data.time && data.time.length) {
      this.listParam.createStartTime = data.time[0];
      this.listParam.createEndTime = data.time[1];
    }
    if (data.executeTime && data.executeTime.length) {
      this.listParam.executeStartTime = data.executeTime[0];
      this.listParam.executeEndTime = data.executeTime[1];
    }
    delete data.executeTime;
    this.getList();
  }

  private handleCancel(row) {
    this.selectId = row.row.id;
    this.showCancelDialog = true;
  }

  private handleWithdraw(row) {
    this.selectId = row.row.id;
    this.showWithdrawDialog = true;
  }

  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `平仓单管理-${new Date()}`
    );
    this.isExporting = false;
  }

  private handleProcessedEdit(row) {
    this.editProcessed.ping = row.row.examineIds;
    this.editProcessed.chu = row.row.closingIds;
    this.editProcessed.remark = row.row.remark;
    this.editProcessed.id = row.row.id;
    this.showEditProcessed = true;
  }

  private async changeStatus(e) {
    if (e === "ADJUST_INVENTORY") {
      this.createWidth = "1270px";
    } else {
      this.createWidth = "900px";
    }
    this.codeList = [];
    this.codeList1 = [];
    this.createClosingPosition.code = null;
    if (e === "STATE_ROLLBACK") {
      this.createClosingPosition.code = null;
    } else {
      this.createClosingPosition.code = [];
    }
    this.createClosingPosition.code1 = null;
    this.createClosingPosition.orderStatus = "";
    this.createClosingPosition.orderStatus1 = "";
    this.mergeArr = [];
    this.mergeArr1 = [];
    console.log("this.getClosureTypeList", this.getClosureTypeList);
    if (e) {
      if (this.getClosureTypeList.findIndex((it) => it.name === e) > -1) {
        this.getClosureOrderTypeList =
          this.getClosureTypeList[
            this.getClosureTypeList.findIndex((it) => it.name === e)
          ].allowOrders;
        let xc = {
          type: e,
        };
        const ress: any = await getNotion(xc);
        this.createClosingPosition.important = ress.notion;
      }
    }
  }

  private deliveryNoteIdList = [] as any;
  private async getDeliveryNoteId(name) {
    // if(this.createClosingPosition.guest1 && name) {
    //   const res:any = await getDeliveryNotesCode(name,this.createClosingPosition.guest1)
    //   this.deliveryNoteIdList = res
    // } else {
    //   this.$notify({
    //     title: "提示",
    //     message: "请先选择调入客人信息！",
    //     type: "warning",
    //     duration: 2000,
    //   });
    // }
    let params = {
      code: name,
      customerId: this.createClosingPosition.guest1,
      company: this.createClosingPosition.company,
      orderType: 'DELIVERY_NOTE',
    };
    const res: any = await getRelateOrderId(params);
    this.deliveryNoteIdList = res
  }

  private viewGuestsStock() {
    this.$router.push("/guestsInStock");
  }

  private searchCustomerOptions = [];
  private async searchCustomer(name = "") {
    const res: any = (await getRecipients({ pushType: "USER_PUSH" })) as any;
    this.searchCustomerOptions = res;
    this.searchForm[5].options = res;
    this.searchForm[6].options = res;
  }

  private async processedSetUp() {
    this.loading = true;
    this.showProcessed = true;
    const res: any = await getClosureOrderSetting();
    this.processedList = res.map((e) => {
      return {
        id: e.id,
        type: e.type,
        typeDesc: e.typeDesc,
        remark: e.remark,
        examineName: e.handlers
          ? e.handlers
              .map((it) => {
                return it.name;
              })
              .toString()
          : null,
        closingName: e.approves
          ? e.approves
              .map((it) => {
                return it.name;
              })
              .toString()
          : null,
        examineIds: e.handlers
          ? e.handlers.map((it) => {
              return it.id;
            })
          : null,
        closingIds: e.approves
          ? e.approves.map((it) => {
              return it.id;
            })
          : null,
      };
    });
    this.loading = false;
    // this.processedList = [{type: 1,remark: 1,closingName: 1,examineName: 1}]
    console.log("平仓处理人设置数据", this.processedList);
  }
  private withdramSubmit() {
    this.$confirm("确定撤回平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        // let data = {
        //   id: this.selectId,
        //   // reason: this.CancelDialogContent
        // };
        await revertClosureOrder(this.selectId)
          .then((res) => {
            this.showWithdrawDialog = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private cancelSubmit() {
    this.$confirm("确定作废平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.selectId,
          reason: this.CancelDialogContent,
        };
        await invalidClosureOrder(data)
          .then((res) => {
            this.showCancelDialog = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private showExecute = false;
  private executeTime = '';
  private executeId = "";
  private handelExecute(row) {
    this.executeTime = '';
    this.showExecute = true;
    this.executeId = row.row.id
    if(row.row.executeTime) {
      this.executeTime = row.row.executeTime
    }
  }
  private async postExecuteTime() {
    let data = {
      id: this.executeId,
      executeTime: this.executeTime
    }
    await postExecuteTime(data).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
      this.showExecute = false;
    }).catch(err => {
      console.log(err)
    })
  }
  private editProcesseSubmit() {
    this.$confirm("确定更改平仓处理人设置吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.editProcessed.id,
          handlerIds: this.editProcessed.ping,
          approveIds: this.editProcessed.chu,
          remark: this.editProcessed.remark,
        };
        await putClosureOrderSetting(data)
          .then(async (res) => {
            this.showEditProcessed = false;
            await this.getSetting();
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private getClosureTypeList = [];
  private getClosureOrderTypeList = [];
  private async getClosureType() {
    const res: any = await getClosureType();
    this.searchForm[
      this.searchForm.findIndex((e) => e.key === "type")
    ].options = res;
    // this.getClosureTypeList = res
  }

  private async getAllowType() {
    const res: any = await getAllowType();
    this.getClosureTypeList = res;
    console.log(this.getClosureTypeList);
    console.log("getClosureTypeList", res);
  }

  private async getClosureOrderType() {
    const res: any = await getClosureOrderType();
    this.searchForm[
      this.searchForm.findIndex((e) => e.key === "orderType")
    ].options = res;
    // this.getClosureOrderTypeList = res
  }

  private codeList = [];
  private codeList1 = [];
  private async getRelateOrderId(code = null) {
    let params = {
      code: code,
      customerId: this.createClosingPosition.guest,
      company: this.createClosingPosition.company,
      orderType: this.createClosingPosition.orderStatus,
    };
    const res: any = await getRelateOrderId(params);
    let newArr = [...this.mergeArr, ...res];
    this.codeList = this.Deduplication(newArr);
    const set = new Set(this.codeList);
    this.codeList = [...set];
  }
  private async getRelateOrderId1(code = null) {
    let params = {
      code: code,
      customerId: this.createClosingPosition.guest1,
      company: this.createClosingPosition.company,
      orderType: this.createClosingPosition.orderStatus1,
    };
    const res: any = await getRelateOrderId(params);
    let newArr = [...this.mergeArr1, ...res];
    this.codeList1 = this.Deduplication(newArr);
    const set = new Set(this.codeList1);
    this.codeList1 = [...set];
  }

  private async CreateClosingPositionSubmit(): Promise<void> {
    // ruleFormMain 左侧基本信息
    // ruleFormBack 状态回退
    // ruleFormError 数据错误和报损出库
    // ruleFormAdjust 和 ruleFormAdjust1 调配库存

    (this.$refs.ruleFormMain as any).validate(
      // 检查左侧基本信息
      async (valid: boolean) => {
        if (valid) {
          try {
            if (this.createClosingPosition.status === "STATE_ROLLBACK") {
              (this.$refs.ruleFormBack as any).validate(
                // 检查状态回退参数
                async (valid: boolean) => {
                  if (valid) {
                    try {
                      this.postSubmit();
                    } catch (error) {
                      console.error(error);
                    }
                  }
                }
              );
            } else if (
              this.createClosingPosition.status === "DATA_ERROR" ||
              this.createClosingPosition.status === "OUTBOUND_ERROR"
            ) {
              (this.$refs.ruleFormError as any).validate(
                // 检查数据错误或者报损出库参数
                async (valid: boolean) => {
                  if (valid) {
                    try {
                      this.postSubmit();
                    } catch (error) {
                      console.error(error);
                    }
                  }
                }
              );
            } else if (
              this.createClosingPosition.status === "ADJUST_INVENTORY"
            ) {
              (this.$refs.ruleFormAdjust as any).validate(
                // 检查调配库存参数1
                async (valid: boolean) => {
                  if (valid) {
                    try {
                      (this.$refs.ruleFormAdjust1 as any).validate(
                        // 检查调配库存参数2
                        async (valid: boolean) => {
                          if (valid) {
                            try {
                              this.postSubmit();
                            } catch (error) {
                              console.error(error);
                            }
                          }
                        }
                      );
                    } catch (error) {
                      console.error(error);
                    }
                  }
                }
              );
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async postSubmit() {
    if (Array.isArray(this.createClosingPosition.code)) {
      if (this.createClosingPosition.status === "ADJUST_INVENTORY") {
        let relateOrdersMAIN = this.createClosingPosition.code.map((ax) => {
          return {
            orderId: ax,
            relateType: "MAIN",
            type: this.createClosingPosition.orderStatus,
            customer: this.createClosingPosition.guest,
          };
        });
        let relateOrdersOUT = [this.createClosingPosition.code1].map((ax) => {
          return {
            orderId: ax,
            relateType: "OUT",
            type: this.createClosingPosition.orderStatus1,
            customer: this.createClosingPosition.guest1
          };
        });
        let deliveryNoteIdOUT = [this.createClosingPosition.code1].map((ax) => {
          return {
            relateType: "DELIVERY",
            type: 'DELIVERY_NOTE',
            orderId: this.createClosingPosition.deliveryNoteId,
          };
        });
        let data = {
          company: this.createClosingPosition.company,
          type: this.createClosingPosition.status,
          remark: this.createClosingPosition.remark,
          relateOrders: [...relateOrdersMAIN, ...relateOrdersOUT, ...deliveryNoteIdOUT],
        };
        await postClosureOrder(data)
          .then(async (res) => {
            this.showCreateClosingPosition = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.initCreateClosingPosition();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let data = {
          company: this.createClosingPosition.company,
          type: this.createClosingPosition.status,
          remark: this.createClosingPosition.remark,
          relateOrders: this.createClosingPosition.code.map((ax) => {
            return {
              orderId: ax,
              relateType: "MAIN",
              type: this.createClosingPosition.orderStatus,
              customer: this.createClosingPosition.guest,
            };
          }),
        };
        await postClosureOrder(data)
          .then(async (res) => {
            this.showCreateClosingPosition = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.initCreateClosingPosition();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      let data = {
        company: this.createClosingPosition.company,
        type: this.createClosingPosition.status,
        remark: this.createClosingPosition.remark,
        relateOrders: [
          {
            orderId: this.createClosingPosition.code,
            relateType: "MAIN",
            type: this.createClosingPosition.orderStatus,
            customer: this.createClosingPosition.guest,
          },
        ],
      };
      await postClosureOrder(data)
        .then(async (res) => {
          this.showCreateClosingPosition = false;
          this.getList();
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
          this.initCreateClosingPosition();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  private async getSetting() {
    const res: any = await getClosureOrderSetting();
    this.processedList = res.map((e) => {
      return {
        id: e.id,
        type: e.type,
        typeDesc: e.typeDesc,
        remark: e.remark,
        examineName: e.handlers
          ? e.handlers
              .map((it) => {
                return it.name;
              })
              .toString()
          : null,
        closingName: e.approves
          ? e.approves
              .map((it) => {
                return it.name;
              })
              .toString()
          : null,
        examineIds: e.handlers
          ? e.handlers.map((it) => {
              return it.id;
            })
          : null,
        closingIds: e.approves
          ? e.approves.map((it) => {
              return it.id;
            })
          : null,
      };
    });
  }

  private initCreateClosingPosition() {
    this.createClosingPosition = {
      company: "",
      status: "",
      reamrk: "",
      important: "",
      code: null,
      orderStatus: "",
      guest: "",
      guest1: "",
      orderStatus1: "",
      code1: null,
      deliveryNoteId: null
    } as any;
    this.codeList = [];
    this.codeList1 = [];
  }
  private linkClick(scope) {
    this.$router.push(
      `/closingPositionDetail?id=${scope.row.id}&type=${scope.row.type}`
    );
  }

  // 合并专用数组
  private mergeArr = [];
  private mergeArr1 = [];
  private changeValueMultiple(value, options, indexKey) {
    let item = value.map((oi) => {
      return options.find((ex) => ex[indexKey] === oi);
    });
    this.mergeArr = item;
  }
  private changeValueMultiple1(value, options, indexKey) {
    let item = [value].map((oi) => {
      return options.find((ex) => ex[indexKey] === oi);
    });
    this.mergeArr1 = item;
  }

  private Deduplication(arr) {
    // 去重
    for (var i = 0; i < arr.length; i++) {
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i].orderId == arr[j].orderId) {
          arr.splice(j, 1); //第一个等同于第二个，splice方法删除第二个
          j--;
        }
      }
    }
    return arr;
  }

  private changeValue(){
    this.createClosingPosition.code = null
    this.mergeArr = []
    this.codeList = []
  }

  private changeValue1(){
    this.createClosingPosition.code1 = null
    this.createClosingPosition.deliveryNoteId = null;
    this.mergeArr1 = []
    this.codeList1 = []
    this.deliveryNoteIdList = []
  }

}
